import { useMemo } from "react";

type Location = {
  address?: string;
  city?: string;
  state?: string;
  postalCode?: string;
};

export const useFormattedAddress = (location?: Location): string => {
  const formattedAddress = useMemo(() => {
    if (!location) return "";

    const addressParts = [
      location.address,
      location.city,
      location.state,
      location.postalCode,
    ].filter((part) => part?.trim());

    return addressParts.join(", ");
  }, [location]);

  return formattedAddress;
};
